module.exports = __webpack_public_path__ + "img/service-order-scan.52ad1919.svg";